import styled, { css } from "styled-components";

import { mobile } from "@sellernote/ui/src/styles/functions";

import { fadeInAndSpringAnimation, fadeUpAnimation } from "../index.styles";

const sectionUtility = styled.section<{ backgroundColor: string }>`
  padding: 80px 0 40px;
  background-color: ${({ backgroundColor }) => backgroundColor};

  ${mobile(css`
    padding: 48px 0px;
  `)}
`;

const container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  .section-title-wrapper {
    width: 100%;

    ${mobile(css`
      padding: 0 16px;
    `)}

    h3 {
      text-align: center;

      ${mobile(css`
        padding-left: 8px;
        animation-delay: 0.2s;
      `)};
    }
  }

  ${fadeUpAnimation}

  ${fadeInAndSpringAnimation}
`;

export default {
  sectionUtility,
  container,
};
